import presentacion from './presentacion'
import asincrono1 from './asincrono1';
import asincrono2 from './asincrono2';
import asincrono3 from './asincrono3';
import asincrono4 from './asincrono4';
import asincrono5 from './asincrono5';
import asincrono6 from './asincrono6';

const lecciones = [presentacion, asincrono1, asincrono2, asincrono3, asincrono4, asincrono5, asincrono6];

export default lecciones;